
import { Vue, Component, Watch } from "vue-property-decorator";
import DropdownInput from "@/components/Reusable/CustomInputs/DropdownInput.vue";
import OxygenSelectInput from "@/oxygen/classes/inputs/OxygenSelectInput.vue";
import { configStore, uiStore } from "@/store/store";
import lodash from "lodash";
import { Control } from "@/oxygen/classes/lib/types";
import OxygenControl from "@/oxygen/classes/OxygenControl.vue";
import Icon from "@/components/UI/Icon.vue";
import { BuilderElement } from "@/types/elements";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import { setElementHtmlTag } from "@/lib/elements/utils";

@Component({
  components: {
    Dropdown,
    Icon,
    OxygenControl,
    OxygenSelectInput,
    DropdownInput
  }
})
export default class OxygenTagChooser extends Vue {
  open = false;
  searchQuery = "";

  @Watch("value")
  onValueChange() {
    this.$nextTick(() => {
      // @ts-ignore
      this.$refs.input!.isMenuActive = false;
      // @ts-ignore
      this.$refs.input!.blur();
    });
  }

  get control(): Control {
    return {
      type: "select",
      name: "Tag",
      slug: "tag",
      items: this.tags,
      disableVariable: true
    };
  }

  get element() {
    return uiStore.activeElement;
  }

  get builderElement(): BuilderElement | null {
    if (!this.element) return null;
    return configStore.element(this.element.data.type);
  }

  get htmlTag() {
    if (!this.element) return null;
    return this.builderElement?.htmlTag;
  }

  get tags() {
    if (!this.element) return [];

    const tags = [...(this.htmlTag?.options || [])];
    return this.defaultTag ? [this.defaultTag, ...tags] : tags;
  }

  get defaultTag() {
    return this.htmlTag?.default;
  }

  get value() {
    return (
      lodash.get(
        uiStore.activeElement,
        `data.properties.settings.advanced.tag`
      ) || this.defaultTag
    );
  }

  setValue(newTag: string) {
    if (!uiStore.activeElementId) return;

    if (!this.isValidHtmlTagName(newTag)) {
      this.handleInvalidTag();
      return;
    }

    setElementHtmlTag(uiStore.activeElementId, newTag);
  }

  handleInvalidTag() {
    this.$nextTick(() => {
      if (this.defaultTag) {
        this.searchQuery = this.defaultTag;
      }
    });
  }

  isValidHtmlTagName(tagName: string) {
    const htmlTagNamePattern = /^[a-zA-Z][a-zA-Z0-9-]*$/;
    return htmlTagNamePattern.test(tagName);
  }

  get doesQueryMatchAnyTag() {
    return this.tags?.some(tag => tag === this.searchQuery);
  }
}
